import React from "react";
import {Col, Row} from "antd";
import {PageContainer} from "@/components/PageContainer/PageContainer";
import Logo from "./icons/Logo.svg";
import LogoBlack from "./icons/Logo_black.svg";
import {useStore} from "@/store/useStore";
import {TotalAvailableSpaces} from "@/components/Header/TotalAvailableSpaces";
import {getRootPageRoute} from "@/routes/routes";
import {useNavigate} from 'react-router-dom';

export const HeaderMiddle = (props: any) => {
    const { useIncreasedContrastTheme } = useStore();
    const navigate = useNavigate();
    
    return (
        <PageContainer
            height={`200px`}
            mainBackgroundColor={useIncreasedContrastTheme ? `#E7F3EF` : `var(--main-color-white)`}
            leftBackgroundColor={useIncreasedContrastTheme ? `#E7F3EF` : `var(--main-color-dark-gold)`}
            rightBackgroundColor={useIncreasedContrastTheme ? `#E7F3EF` : `var(--main-color-deep-blue)`}
            centerBackgroundColor={useIncreasedContrastTheme ? `#E7F3EF` : `var(--main-gradient-1)`}
        >
            <Row align="middle" justify="space-between" style={{height: '200px', flexWrap: 'nowrap', gap: 16}}>
                <Col style={{display: "flex", minWidth: 0, flexShrink: 1}}>
                    <img onClick={() => navigate(getRootPageRoute())} style={{ width: '100%', minWidth: 100, maxWidth: '100%' }} src={useIncreasedContrastTheme ? LogoBlack : Logo} alt={'Logo'} />
                </Col>
                <Col style={{display: "flex", alignItems: "center", minWidth: 0, flexShrink: 0}}>
                    <TotalAvailableSpaces/>
                </Col>
            </Row>
        </PageContainer>
    )
}